import _ from 'lodash';
const isTrainingSession = (content) => {
    return _.includes(content?.articleTypes, "TRAINING_SESSION");
}

export default isTrainingSession;